import { Button, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { useRecordContext } from "react-admin";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function Disclosures({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "disclosures";
  const sectionTitle =
    "Disclosures - Key information that is required for disclosure in legal documents";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.disclosures;
  const productType = record?.data?.basic?.type;
  const subType = record?.data?.basic?.subType;
  const division = record?.data?.basic?.division;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;

  const [showDetail, setShowDetail] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        sLicensingDisclosure: data?.sLicensingDisclosure || "",
        sGoverningBody: data?.sGoverningBody || "",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        {productModulesGroup?.includes("license") && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Licensing Disclosure: Please list all the licenses related to
                this product
              </Typography>
              <Controller
                name="sLicensingDisclosure"
                control={control}
                render={({ field }) => (
                  <CustomProductTextField
                    {...field}
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    placeholder="Licensing Disclosure"
                    error={!!errors.sLicensingDisclosure}
                    helperText={errors.sLicensingDisclosure?.message?.toString()}
                  />
                )}
              />
            </Grid>
            {/* Governing Body: Please list legal authority over the product agreement or contract */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Governing Body: Please list legal authority over the product
                agreement or contract
              </Typography>
              <Controller
                name="sGoverningBody"
                control={control}
                render={({ field }) => (
                  <CustomProductTextField
                    {...field}
                    fullWidth
                    variant="outlined"
                    placeholder="Governing Body"
                    error={!!errors.sGoverningBody}
                    helperText={errors.sGoverningBody?.message?.toString()}
                  />
                )}
              />
            </Grid>
          </Grid>
        )}
      </Box>
      {/* Form Actions */}
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          disabled={!isDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
